import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../context/authProvider";
import MenuIcon from "../../../img/svg/menuIcon";
import GMTIcon from "../../../img/svg/gmtIcon";
import UserIcon from "../../../img/svg/userIcon";
import { useEffect, useState } from "react";
import XIcon from "../../../img/svg/xIcon";

export default function Header({ scrollY, isMobile }: { scrollY: number, isMobile: boolean }) {

    const { user } = useAuth();
    const location = useLocation();

    const [burguer, setBurguer] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const headerBase = location.pathname !== "/";

    if (isMobile) {
        return (
            <>
                <header className={`fixed top-0 left-0 w-full h-20 z-[100] transition-all duration-300 ${scrollY > 20 ? (headerBase ? "glass shadow-sm" : "glass-dark shadow-lg") : (headerBase ? "bg-moninho" : "bg-transparent")}`}>
                    <div className="flex justify-between px-6 h-full items-center">
                        <button className="p-2 transition-transform active:scale-95" onClick={() => setBurguer(true)}>
                            <MenuIcon fill={headerBase && scrollY <= 20 ? "#111827" : (headerBase ? "#111827" : "white")} />
                        </button>

                        <Link to="/" className="transition-opacity hover:opacity-80">
                            <GMTIcon width="120px" fill={headerBase || scrollY > 20 ? "#111827" : "white"} />
                        </Link>

                        <Link to={user ? "/me" : "/gatekeeper"} className="p-2 transition-transform active:scale-95">
                            <UserIcon width="24px" fill={headerBase || scrollY > 20 ? "#111827" : "#FFFFFF"} />
                        </Link>
                    </div>
                </header>

                {/* Mobile Menu Overlay */}
                <div className={`fixed inset-0 z-[110] transition-all duration-500 ease-in-out ${burguer ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}>
                    <div className="absolute inset-0 bg-primary/40 backdrop-blur-sm" onClick={() => setBurguer(false)} />
                    <div className={`absolute top-0 left-0 h-full w-[80%] max-w-[300px] bg-white shadow-2xl transition-transform duration-500 ease-out ${burguer ? "translate-x-0" : "-translate-x-full"}`}>
                        <div className="p-6 flex flex-col h-full">
                            <div className="flex justify-between items-center mb-10">
                                <GMTIcon width="100px" fill="#111827" />
                                <button onClick={() => setBurguer(false)} className="p-2 hover:bg-surface rounded-full transition-colors">
                                    <XIcon />
                                </button>
                            </div>

                            <nav className="flex flex-col gap-2">
                                {[
                                    { name: "INÍCIO", path: "/" },
                                    { name: "RELÓGIOS", path: "/watches" },
                                    { name: "SOBRE", path: "/about" },
                                    { name: "COMPRA SEGURA", path: "/safe-buying" },
                                    { name: "FAQ", path: "/faq" }
                                ].map((item) => (
                                    <Link
                                        key={item.path}
                                        className={`p-4 rounded-xl font-medium transition-all ${location.pathname === item.path ? "bg-secondary text-white shadow-md shadow-secondary/20" : "text-primary hover:bg-surface"}`}
                                        to={item.path}
                                        onClick={() => setBurguer(false)}
                                    >
                                        {item.name}
                                    </Link>
                                ))}
                            </nav>

                            <div className="mt-auto pt-6 border-t border-surface">
                                <Link
                                    to={user ? "/me" : "/gatekeeper"}
                                    className="flex items-center gap-3 p-4 rounded-xl font-bold bg-primary text-white hover:bg-primary/90 transition-colors"
                                    onClick={() => setBurguer(false)}
                                >
                                    <UserIcon width="20px" fill="white" />
                                    {user ? "MINHA ÁREA" : "ENTRAR"}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <header className={`fixed top-0 left-0 w-full h-20 z-[100] transition-all duration-500 ${scrollY > 50 ? (headerBase ? "glass shadow-sm h-16" : "glass-dark shadow-xl h-16") : (headerBase ? "bg-moninho" : "bg-transparent")}`}>
            <div className="max-w-7xl mx-auto flex justify-between px-10 h-full items-center">
                <nav className="flex items-center gap-10 flex-1">
                    {[
                        { name: "RELÓGIOS", path: "/watches" },
                        { name: "SOBRE", path: "/about" },
                        { name: "COMPRA SEGURA", path: "/safe-buying" },
                        { name: "FAQ", path: "/faq" }
                    ].map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`font-medium tracking-wide whitespace-nowrap transition-all hover:text-secondary relative group ${location.pathname === item.path ? "text-secondary" : (headerBase || scrollY > 50 ? "text-primary" : "text-white")}`}
                        >
                            {item.name}
                            <span className={`absolute -bottom-1 left-0 w-0 h-0.5 bg-secondary transition-all duration-300 group-hover:w-full ${location.pathname === item.path ? "w-full" : ""}`} />
                        </Link>
                    ))}
                </nav>

                <div className="flex-1 flex justify-center">
                    <Link to="/" className="transition-transform hover:scale-105 active:scale-95 duration-300">
                        <GMTIcon width={scrollY > 50 ? "130px" : "160px"} fill={headerBase || scrollY > 50 ? "#111827" : "white"} />
                    </Link>
                </div>

                <div className="flex-1 flex justify-end">
                    <Link
                        to={user ? "/me" : "/gatekeeper"}
                        className={`group flex items-center gap-3 px-5 py-2 rounded-full border transition-all duration-300 ${headerBase || scrollY > 50
                            ? "border-primary/10 hover:border-secondary hover:text-secondary text-primary"
                            : "border-white/20 hover:border-white hover:bg-white/10 text-white"
                            }`}
                    >
                        <span className="font-bold text-sm tracking-widest">{user ? "MINHA ÁREA" : "ENTRAR"}</span>
                        <UserIcon width="18px" fill="currentColor" />
                    </Link>
                </div>
            </div>
        </header>
    )
}
